<template>
  <base-modal hide-footer hide-header @close="close">
    <div class="col-12" @click.stop="">
      <h3 class="editor-header">
        {{ $t('traffic_control.report_title') }}
      </h3>
      <div>
        <!-- Details -->
        <div class="row">
          <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('danger_report.contract') }}</span>
            <span
              v-if="report.contract"
              class="item-detail-text"
            >
              {{ report.contract.name }}
            </span>
            <span
              v-else
              class="item-detail-text"
            >
              -
            </span>
          </div>
          <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('common.start_date') }}</span>
            <span class="item-detail-text">{{ toLocalTime(report.start_time) }}</span>
          </div>
          <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('common.end_date') }}</span>
            <span class="item-detail-text">{{ toLocalTime(report.end_time) }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('map.road_number') }}</span>
            <span class="item-detail-text">{{ report.road_number ? report.road_number : "-" }}</span>
          </div>
          <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('road_sign.sec_num') }}</span>
            <span class="item-detail-text">{{ report.road_section ? report.road_section : "-" }}</span>
          </div>
          <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('map.road_name') }}</span>
            <span class="item-detail-text">{{ report.road_name ? report.road_name : "-" }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="item-detail-title">{{ $t('danger_report.description') }}</span>
            <span class="item-detail-text">{{ report.description ? report.description : '-' }}</span>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-end">
          <button class="btn btn-secondary form-button" @click.stop="close">
            {{ $t('common.close') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'TrafficControlReportDetails',
    components: {BaseModal},
    mixins: [restApi, timeUtils],
    props: {
        report: {
            type: Object,
            default: null
        },
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        close: function () {
            this.$emit('close')
        },

        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
    }
}
</script>

<style scoped>
</style>

